import { Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { BANK_INTEGRATION_PLUGINS, type BankIntegrationPlugin, PLUGIN_TRANSLATION_ASSETS } from '@app/ui/shared';
import { SantanderSettingsService } from './santander-settings.service';
import { SantanderFileParserService } from './santander-file-parser.service';
import { SantanderSettingComponent } from './ui/santander-setting.component';

export function provideSantanderPlugin(): Provider[] {
  return [
    SantanderSettingsService,
    SantanderFileParserService,
    {
      provide: PLUGIN_TRANSLATION_ASSETS,
      useValue: {
        pluginId: 'santander',
        basePath: './assets/i18n/plugins/santander',
        locales: ['en', 'pl', 'ru', 'uk'],
      },
      multi: true,
    },
    {
      provide: BANK_INTEGRATION_PLUGINS,
      useFactory: (
        translate: TranslateService,
        state: SantanderSettingsService,
        dialogService: DialogService,
      ): BankIntegrationPlugin => ({
        id: 'santander',
        order: 120,
        bankName: () => translate.instant('screens.santander.labels.bank_name'),
        logoIcon: '/assets/images/banks/santander.svg',
        settingsComponent: SantanderSettingComponent,
        enabled: () => state.santanderEnabled(),
        openImport: () => {
          void import('./ui/santander-import-dialog.component').then(({ SantanderImportDialogComponent }) => {
            dialogService.open(SantanderImportDialogComponent, {
              header: translate.instant('screens.santander.titles.import_dialog'),
              styleClass: 'p-dialog-form p-dialog-maximized',
              modal: true,
              closable: true,
              focusOnShow: false,
            });
          });
        },
      }),
      deps: [TranslateService, SantanderSettingsService, DialogService],
      multi: true,
    },
  ];
}
